export default __webpack_public_path__ + "static/media/moniban-logo.ef132292.webp";